import { render, staticRenderFns } from "./SetRule.vue?vue&type=template&id=9bf3bbba&scoped=true"
import script from "./SetRule.vue?vue&type=script&lang=js"
export * from "./SetRule.vue?vue&type=script&lang=js"
import style0 from "./SetRule.vue?vue&type=style&index=0&id=9bf3bbba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf3bbba",
  null
  
)

export default component.exports